<style type="text/css">
    .table th{
        text-transform: none !important;
    }

</style>
<template>
    <div v-if="$store.state.AppConfig.loggedin_user.role_name =='superadmin'">
        <div class="card">
          <h5 class="card-header">Upload Report</h5>
          <div class="card-body">
            <VeeForm  ref="reportForm" as="div" class="needs-validation" name="report" v-slot="{ errors }">
              <form class="validate-form mt-2 pt-50" method="POST" action="/">
                <div class="row g-3">
                    <div class="col-md-6">
                       <div class="mb-3">
                          <label class="form-label" for="modalEditUserLanguage"><strong>Client<span class="required">*</span></strong></label>
                          <select
                            id="modalEditUserLanguage"
                            name="modalEditUserLanguage"
                            class="select2 form-select form-control"
                            aria-label="Default select example"
                            v-model="report.client"
                          >
                            <option value="">--Select--</option>
                            <option v-if="$store.state.AppConfig.customers.length" v-for="customer in $store.state.AppConfig.customers" :value="customer.CustomerID">{{customer.CompanyName}}</option>
                          </select>
                        </div>
                        <div class="mb-3">
                        	<label class="form-label" for="folder_id"><strong>Folder</strong></label>
                        	<select id="folder_id" name="folder_id" class="select2 form-select form-control" aria-label="Default select example" v-model="report.folder_id">
                        		<option value="">--Select--</option>
                        		<template v-if="folders.length > 0">
                        			<option v-for="folder in folders" :value="folder.id">{{folder.name}}</option>
                        		</template>
                        	</select>
                        </div>

                        <div class="mb-3">
                          <label class="form-label" for="formtabs-last-name"><strong>Report Name<span class="required">*</span></strong></label>
                          <Field  type="text" 
                              class="form-control"
                              name="report_name" 
                              rules="required"
                              v-model="report.report_name" 
                              placeholder="Report Name"
                              label="Report Name">
                          </Field>
                          <small class="text-danger">{{ errors.report_name }}</small>
                        </div>
                    </div>                   
                </div>

                <div class="row g-3">
                    <div class="col-md-6">
                      <FileUpload :data="report" url="/api/service/v1/report/upload"/>
                    </div>                   
                </div>
                <pre>{{ $store.state.AppConfig.client_id }}</pre>
                <div class="pt-4">
                    <button type="button" @click="submitForm" class="btn btn-primary me-sm-3 me-1 waves-effect waves-light">Submit</button>
                    <router-link  class="btn btn-label-primary waves-effect" to="/reports/history">Cancel</router-link>
                  </div>
              </form>
            </VeeForm>
          </div>
        </div>
    </div>
    <div v-else>
      Access denied.
    </div>
</template>

<script>
import jQuery from 'jquery'
import moment from 'moment';
import {Form, Field ,useFieldError,useFormErrors,useValidateForm,useField,useForm} from 'vee-validate';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import '../../js/validation';
import FileUpload from "../../components/FileUpload.vue";

export default {
    name: 'reports',
    components:{
        'VeeForm': Form,
        Field,
        'v-select': vSelect,
        FileUpload
    },
    props: [],
    data(){
        return{
            report: {
              client: "",
              report_name: "",
              file_name: "",
              folder_id: "",
              full_path: "/"
            },
            folders: []
        }   
    },

    created() {
    },
    setup() {
    },
    mounted() {
    	let self = this;
    	console.log('this.$store.state.AppConfig.client_id', this.$store.state.AppConfig.client_id);
    	self.report.client = self.$store.state.AppConfig.client_id;
    	self.$eventBus.on('appconfig-loaded', (val) => {
			self.report.client = self.$store.state.AppConfig.client_id;
        });
    	
    },

    computed:{
    },
    watch:{
    	'report.client': function (new_val, old_val) {
    		console.log('report client change watch call');
    		this.report.folder_id = "";
    		this.report.full_path = "/";
    		this.getClientFolders(new_val);
    	},
    	'report.folder_id': function (new_val, old_val) {
    		this.report.full_path = "/";
    		if (new_val) {
        		let folder_index = this.folders.findIndex(i => i.id == new_val);
        		this.report.full_path = this.folders[folder_index].full_path;
    		}
    	}
    },

    methods:{

    	getClientFolders(client_id) {
    		let self = this;
    		this.$axios.get('/report/folders?client='+self.report.client).then(response => {
    			self.folders = response.data.input_data;
    		})
    		.catch(error => {
    			console.error(error);
    		});
    	},
        newReport(){
          var self = this;
          self.report = {
            client: null,
            report_name: "",
            file_name: ""
          }
        },
      
        async submitForm() {
            const form = this.$refs.reportForm;
            const isValid = await form.validate();

            if (isValid.valid) {
              this.storeReport();
            }
        },

        storeReport(){
          var self = this;
          self.$axios.post('/report', self.report)
            .then(response => {
              if (!response.data.error){ 
                 self.$router.push({ path: '/reports/history' });
              }
              else{
                toastr['error'](response.data.input_data.error_message, 'Error', {
                      closeButton: true,
                      tapToDismiss: false,
                      timeOut: 5000,
                      rtl: false,
                  });
              }
            })
            .catch(error => {
              console.error(error);
            });
        },

        updateFilename(filename){
          this.report.file_name = filename;
        }
        
    },
}
</script>
